const settings = {
	form: '#filters',
	toggle: '.filter-form-toggle'
}

const init = () => {
	const form = document.querySelector(settings.form);
	const toggle = document.querySelector(settings.toggle);
	if (form) {
		window.addEventListener('resize', () => {
			updateForm(false)
		});
		window.addEventListener('formRefreshed', () => {
			updateForm(false)
		});
		updateForm(true);
	}
}

function updateForm(initialLoad) {
	const form = document.querySelector(settings.form);
	const toggle = document.querySelector(settings.toggle);
	if (window.innerWidth < 992) {
		form.classList.add('collapse');
		toggle.style.display = 'block';
		if (initialLoad) {
			form.classList.remove('show');
			toggle.classList.add('collapsed');
		}
	} else {
		form.classList.remove('collapse');
		toggle.style.display = 'none';
	}
}

init();
